import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      marginTop: '10px',
      '@media (max-width: 1280px)': {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
      }
    },
    competences: {
      transform: 'translateY(-70px)',
      '@media (min-width: 1020px) and (max-width: 1280px)': {
        marginTop: '10px'
      },
      '@media (max-width: 1280px)': {
        transform: 'translateY(0)'
      }
    },
    actuQuiz: {
      transform: 'translateY(0)',
      '@media (max-width: 1280px)': {
        transform: 'translateY(0)'
      }
    },
    buttonContainer: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
